import React, { ErrorInfo, ReactNode } from 'react';

type ErrorBoundaryProps = {
  children: ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
};

type ErrorBoundaryState = {
  hasError: boolean;
  errorMessage?: Error;
};

export class ModuleErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, errorMessage: undefined };
  }

  static getDerivedStateFromError(err: Error): ErrorBoundaryState {
    return { hasError: true, errorMessage: err };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by the boundary:', error, errorInfo);
    const { onError } = this.props;
    if (onError) {
      if (['development', 'staging'].indexOf(__BUILD_ENV__ ?? '') !== -1) {
        onError(error, errorInfo);
      }
    }
  }

  override render() {
    const { hasError } = this.state;
    if (hasError) {
      return null;
    }
    return this.props.children;
  }
}
